import React, { useRef, useEffect } from "react";
import { Toast } from "primereact/toast";
import "./style.scss";

const ErrorToast = ({ summary, detail, onClose }) => {
  const toast = useRef(null);
  const hasShown = useRef(false);
  const toastLife = 3000;

  useEffect(() => {
    if (toast.current && !hasShown.current) {
      hasShown.current = true;

      toast.current.show({
        severity: "error",
        summary,
        detail,
        icon: "pi pi-times-circle",
        life: toastLife,
        closable: true,
      });
      setTimeout(() => {
        onClose(false);
        hasShown.current = false;
      }, toastLife + 100);
    }
  }, [summary, detail]);

  return summary && detail && <Toast ref={toast} position="bottom-right" />;
};

export default ErrorToast;
